import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { style } from 'typestyle';
import { px } from 'csx';
import { FAVOURITE_CAROUSEL, FeatureFlag, getFlag, setFlag } from './feature-flags';
import { StorageModel } from '../../modules/storage/model';

const styles = {
  container: style({
    position: 'fixed',
    bottom: 0,
    left: 0,
    background: 'white',
    zIndex: 9999,
    padding: px(20),
    border: '1px solid black',
  }),
  list: style({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginBottom: px(20),
  }),
};

const StorageInput = (itemKey: FeatureFlag) => (
  <input type="checkbox" checked={getFlag(itemKey)} onChange={(evt) => setFlag(itemKey, evt.target.checked)} />
);

@inject(deps)
@observer
export default class FeatureFlagWidget extends Component<Record<string, never>> {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
  }

  render() {
    const storage = this.props.model.storage;
    const { show } = this.state;

    if (!show || process.env.APP_ENV !== 'test') return null;

    return (
      <div className={styles.container}>
        <ul className={styles.list}>
          <li>
            <label>Favourite carousels {StorageInput(FAVOURITE_CAROUSEL)}</label>
          </li>
        </ul>
        <button onClick={() => this.setState({ show: false })}>Hide</button>
      </div>
    );
  }
}
